import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.1.4_react@19.1.0__@emotion+styled@_qpknszqoxa5cmpk6qjxkgziavi/node_modules/@mui/material/esm/Divider/Divider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.1.4_react@19.1.0__@emotion+styled@_qpknszqoxa5cmpk6qjxkgziavi/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.5_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.89.2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.5_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.89.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/MaterialsBar/MaterialsBar.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/media/Picture/PictureGallery.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/DictionaryBox/DictionaryBox.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.5_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.89.2/node_modules/next/font/google/target.css?{\"path\":\"src/components/FancyTitle/FancyTitle.jsx\",\"import\":\"Noto_Nastaliq_Urdu\",\"arguments\":[{\"subsets\":[\"arabic\"],\"display\":\"swap\",\"weight\":\"400\",\"fallback\":[\"IranNastaliq\",\"serif\"]}],\"variableName\":\"notoNastaliqUrdu\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/shop/carpets/[titleAtURL]/product-page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/MoreOfThis/ScrollableProductList.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Price/PriceGrid.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Product/AboutTheProduct.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/BuyNowBtn.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/CarpetVisualizer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductCard/DynamicProductTitle.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductCard/ProductMeasurements.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductCard/UnitAwareProductSize.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductDensity.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Product/ProductSummaryBottom.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductThickness.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ProductWeight.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Product/ShoppingBtns.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ScrollToTop/ScrollToTopBtn.jsx");
